
import {
  experience,
  services,
  popularServices,
  questions,
} from "~/data/datacenterServices";
import Modal from "~/components/rebranding/modal/Modal.vue";

export default {
  data() {
    return {
      copiedIndex: null,
      activeSection: "",
      FormTitle: "",
      solotionTab: 0,
      experience,
      services,
      popularServices,
      questions,
    };
  },
  components: {
    Modal,
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "خدمات دیتاسنتر آبالون | سرور اختصاصی و کولوکیشن",
      meta: [
        {
          name: "description",
          content:
            "خدمات دیتاسنتر آبالون | سرور اختصاصی و کولوکیشن | مستقر در دیتاسنترهای پیشرفته در سراسر ایران | معماری ابری یا Bare Metal | متناسب با نیاز سازمان‌ها",
        },
        {
          name: "keywords",
          content: "خدمات دیتاسنتر آبالون, سرور اختصاصی, کولوکیشن",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/datacenter-services",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "خدمات دیتاسنتر آبالون | سرور اختصاصی و کولوکیشن",
        },
        {
          property: "og:description",
          content:
            "خدمات دیتاسنتر آبالون | سرور اختصاصی و کولوکیشن | مستقر در دیتاسنترهای پیشرفته در سراسر ایران | معماری ابری یا Bare Metal | متناسب با نیاز سازمان‌ها",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/datacenter-services",
        },
        {
          name: "twitter:title",
          title: "خدمات دیتاسنتر آبالون | سرور اختصاصی و کولوکیشن",
        },
        {
          name: "twitter:description",
          content:
            "خدمات دیتاسنتر آبالون | سرور اختصاصی و کولوکیشن | مستقر در دیتاسنترهای پیشرفته در سراسر ایران | معماری ابری یا Bare Metal | متناسب با نیاز سازمان‌ها",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/datacenter-services",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "خدمات دیتاسنتر آبالون شامل چه سرویس‌هایی می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "خدمات دیتاسنتر آبالون شامل سرور اختصاصی و سرویس کولوکیشن است. این سرویس‌ها امکان دسترسی به منابع سخت‌افزاری قدرتمند یا استقرار تجهیزات سازمانی در دیتاسنترهای پیشرفته آبالون را با امنیت بالا و پایداری تضمین‌شده فراهم می‌کنند.",
                },
              },
              {
                "@type": "Question",
                name: "تفاوت سرور اختصاصی و کولوکیشن در دیتاسنتر آبالون چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "به‌عنوان بخشی از خدمات دیتاسنتر آبالون، در سرویس سرور اختصاصی، منابع سخت‌افزاری توسط آبالون تأمین و متناسب با نیاز شما سفارشی‌سازی می‌شود. در سرویس کولوکیشن، تجهیزات متعلق به سازمان شما در مراکز داده آبالون مستقر می‌شود و زیرساخت ایمن و پایدار دیتاسنتر از آنها میزبانی می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان انتخاب موقعیت جغرافیایی دیتاسنتر وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. آبالون دیتاسنترهای خود را در نقاط کلیدی ایران مستقر کرده است تا بتوانید بر اساس نیاز خود، نزدیک‌ترین دیتاسنتر را برای دسترسی با کمترین تأخیر انتخاب کنید. همچنین برای اهداف خاص مانند پشتیبان‌گیری، بازیابی پس از بحران (DR) یا توزیع بار، امکان استفاده از مراکز داده واقع در سایر استان‌ها فراهم است تا انعطاف‌پذیری و تداوم سرویس تضمین شود.",
                },
              },
              {
                "@type": "Question",
                name: "مزیت استفاده از خدمات دیتاسنتر آبالون نسبت به نگهداری داخلی تجهیزات چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "با خدمات دیتاسنتر آبالون نیازی به سرمایه‌گذاری سنگین روی زیرساخت داخلی ندارید. برق پایدار، سیستم‌های کولینگ پیشرفته، امنیت چند لایه و مانیتورینگ مداوم در اختیار شماست و تیم پشتیبانی ۲۴/۷ آبالون، دسترس‌پذیری مداوم و عملکرد بهینه تجهیزات را تضمین می‌کند.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "خدمات دیتاسنتر آبالون",
            },
            author: {
              "@type": "Person",
              name: "Amirhosein",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
